<div class="loading-container">
  <mat-spinner [diameter]="diameter"></mat-spinner>
  <p>{{ message }}</p>
</div>
